// Views
import companyDetail from './companyDetail';
import jobdetail from './jobdetail';
import findjobs from './findjobs';
import findcompanies from './findcompanies';
import mypage from './mypage';
import spotlight from './spotlight';
import emailverification from './emailverification';
import recoverpassword from './recoverpassword';
import recoveruser from './recoveruser';
import favorites from './favorites';
import tests from './tests';
import resourcesInternal from './resourcesInternal';
import calendar from './calendar';

// Other
import general from './general';
import shared from './shared';
import components from './components';
import cts from './cts';
import errors from './errors';
import gptw from './gptw';

export default {
    companyDetail,
    jobdetail,
    findjobs,
    findcompanies,
    mypage,
    spotlight,
    emailverification,
    recoverpassword,
    recoveruser,
    favorites,
    tests,
    calendar,

    general,
    shared,
    components,
    cts,
    errors,
    gptw,
    resourcesInternal,
    calendar,
};
